import { SourceBlock } from "../pipeline/tiles.pipeline.sourceblock";
export class TileViewBase extends SourceBlock {
    constructor() {
        super();
        this._activ = new Map();
    }
    setContext(state, display, metrics, options) {
        if (!state || !display) {
            this._doClearContext(state, this._activ, options);
            return;
        }
        this._doValidateContext(state, display, metrics, this._activ, options);
    }
    _doClearContext(state, activAddresses, options) {
        if (state) {
            let deleted = Array.from(activAddresses.values());
            activAddresses.clear();
            if (options?.dispatchEvent ?? true) {
                if (deleted.length && this._removedObservable?.hasObservers()) {
                    this._removedObservable.notifyObservers(deleted, -1, this, this);
                }
            }
        }
    }
    _doValidateContext(state, display, metrics, activAddresses, options) { }
}
//# sourceMappingURL=tiles.map.view.base.js.map